import jwtDecode from 'jwt-decode'
import { handleErrorResponseFromBackend } from '../sentry/handlers/backendHandler'

export const appendQueryParam = (queryString, paramName, paramValue) => {
  let result = queryString
  if (paramName && paramValue) {
    if (queryString.length) {
      result = `${queryString}&${paramName}=${paramValue}`
    } else {
      result = `?${paramName}=${paramValue}`
    }
  }
  return result
}

export const appendPageInfoQueryParams = ({ pageInfo }) => {
  let params = ''
  if (pageInfo) {
    params = appendQueryParam(params, 'page', pageInfo.page)
    params = appendQueryParam(params, 'size', pageInfo.size)
    if (pageInfo?.sortList?.length > 0) {
      params = appendQueryParam(params, 'sort', pageInfo.sortList)
    }
  }
  return params
}

export class ApiError extends Error {
  constructor(message, data, status, description, requestUrl, traceId) {
    super(message)

    this.data = data
    this.status = status
    this.description = description
    this.requestUrl = requestUrl
    this.traceId = traceId
  }
}

export const genericHandleApiError = (response, requestUrl, requestBody) =>
  response
    .clone()
    .json()
    .catch(() =>
      response.text().then(message => ({
        message: message || 'empty response from backend',
        requestUrl,
        requestBody,
      })),
    )
    .then(data => {
      handleErrorResponseFromBackend(data)
      throw new ApiError(
        data.message || 'No message provided',
        data,
        response.status,
        null,
        requestUrl,
        data.traceId || 'No traceId provided',
      )
    })

export const decodeJwt = data => {
  const decodedToken = jwtDecode(data.token)
  const decodedRefreshToken = jwtDecode(data.refreshToken)
  return {
    name: decodedToken.name,
    token: data.token,
    decodedToken,
    refreshToken: data.refreshToken,
    decodedRefreshToken,
  }
}

export const setToken = (headers, token) => {
  headers.set('Authorization', `Bearer ${token}`)
}

export const setupJsonHeaders = () => {
  const myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('Accept', 'application/json')
  return myHeaders
}

export const setupJsonJWTHeaders = token => {
  const myHeaders = setupJsonHeaders()
  setToken(myHeaders, token)
  return myHeaders
}

export const requestOk = response =>
  response.status >= 200 && response.status < 300
